module.exports = __webpack_public_path__ + "static/home.2512b083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/screenshots/pingusenglish/home.jpg
// module id = ./src/app/data/screenshots/pingusenglish/home.jpg
// module chunks = 6